<div class="knowledgeHub_abandonedPopContent">
  <div class="knowledgeHub_abandonedPopHeader">
    <div class="knowledgeHub_abandonedPopTitle">{{popupdata?.headline}}</div>
    <div class="extlink_popClose" aria-label="Close" (click)="onClose()">X</div>
    <div class="clearboth"></div>
  </div>
  <div class="knowledgeHub_abandonedPopText">
    <p [innerHTML]="popupdata?.message1" class="popup_Text1"></p>
    <p [innerHTML]="popupdata?.message2" class="popup_Text1"></p>
  </div>
  <div class="knowledgeHub_abandonedPopBtns">
    <button class="knowledgeHub_abandonedPopBtn extlink_popContBtn"
      (click)="onContinue()">{{popupdata?.label1}}</button>
    <button class="knowledgeHub_abandonedPopBtn extlink_popCancelBtn"
      (click)="onClose()">{{popupdata?.label2}}</button>
  </div>
  <div class="knowledgedocnumberUk">{{popupdata?.jobBagCode}}</div>
</div>
